import React, { FC } from 'react'
import { Button, Heading, Modal, Text } from '@afterpaytouch/core'
import { useDisputeTranslation } from '../hooks'
import { useConsumerSizes } from '../../../utils/responsive'
import { useDisputeCreationModalContext } from '../DisputeCreationModalContext'
import { TrackOnMount } from '../../../integrations/amplitude'
import { TrackingEvent } from '../../../model/amplitude'

export const CreateFailure: FC = () => {
  const { textSize } = useConsumerSizes()
  const t = useDisputeTranslation()
  const {
    result: { title, message },
    closeModal,
  } = useDisputeCreationModalContext()

  const cta = t('result:failure:closeCTA')

  return (
    <>
      <TrackOnMount eventName={TrackingEvent.VIEWED_CREATE_DISPUTE_FAILURE} />
      <Modal.Header divider={true}>
        <div className='text-center'>
          <Heading size='L'>{title}</Heading>
        </div>
      </Modal.Header>
      <Modal.Content>
        <Text size={textSize}>{message}</Text>
        <div className='mt-16'>
          <Button padding='Fluid' onClick={closeModal}>
            {cta}
          </Button>
        </div>
      </Modal.Content>
    </>
  )
}
